var BitArray_Expandido = 1;
var BitArray_Colapsado = 2;
var gNumBloques = [
    0, 1, 1, 1, 1, 2, 1, 1, 1, 2, 2, 2, 1, 2, 1, 1,
    1, 2, 2, 2, 2, 3, 2, 2, 1, 2, 2, 2, 1, 2, 1, 1,
    1, 2, 2, 2, 2, 3, 2, 2, 2, 3, 3, 3, 2, 3, 2, 2,
    1, 2, 2, 2, 2, 3, 2, 2, 1, 2, 2, 2, 1, 2, 1, 1,
    1, 2, 2, 2, 2, 3, 2, 2, 2, 3, 3, 3, 2, 3, 2, 2,
    2, 3, 3, 3, 3, 4, 3, 3, 2, 3, 3, 3, 2, 3, 2, 2,
    1, 2, 2, 2, 2, 3, 2, 2, 2, 3, 3, 3, 2, 3, 2, 2,
    1, 2, 2, 2, 2, 3, 2, 2, 1, 2, 2, 2, 1, 2, 1, 1,
    1, 2, 2, 2, 2, 3, 2, 2, 2, 3, 3, 3, 2, 3, 2, 2,
    2, 3, 3, 3, 3, 4, 3, 3, 2, 3, 3, 3, 2, 3, 2, 2,
    2, 3, 3, 3, 3, 4, 3, 3, 3, 4, 4, 4, 3, 4, 3, 3,
    2, 3, 3, 3, 3, 4, 3, 3, 2, 3, 3, 3, 2, 3, 2, 2,
    1, 2, 2, 2, 2, 3, 2, 2, 2, 3, 3, 3, 2, 3, 2, 2,
    2, 3, 3, 3, 3, 4, 3, 3, 2, 3, 3, 3, 2, 3, 2, 2,
    1, 2, 2, 2, 2, 3, 2, 2, 2, 3, 3, 3, 2, 3, 2, 2,
    1, 2, 2, 2, 2, 3, 2, 2, 1, 2, 2, 2, 1, 2, 1, 1
];
var PosBit1 = [
    8, 7, 6, 6, 5, 5, 5, 5, 4, 4, 4, 4, 4, 4, 4, 4,
    3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
    2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
    2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0
];
var PosBit2 = [
    8, 8, 8, 7, 8, 7, 6, 6, 8, 7, 6, 6, 5, 5, 5, 5,
    8, 7, 6, 6, 5, 5, 5, 5, 4, 4, 4, 4, 4, 4, 4, 4,
    8, 7, 6, 6, 5, 5, 5, 5, 4, 4, 4, 4, 4, 4, 4, 4,
    3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
    8, 7, 6, 6, 5, 5, 5, 5, 4, 4, 4, 4, 4, 4, 4, 4,
    3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
    2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
    2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
    8, 7, 6, 6, 5, 5, 5, 5, 4, 4, 4, 4, 4, 4, 4, 4,
    3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
    2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
    2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1
];
var PosBit3 = [
    8, 8, 8, 8, 8, 8, 8, 7, 8, 8, 8, 7, 8, 7, 6, 6,
    8, 8, 8, 7, 8, 7, 6, 6, 8, 7, 6, 6, 5, 5, 5, 5,
    8, 8, 8, 7, 8, 7, 6, 6, 8, 7, 6, 6, 5, 5, 5, 5,
    8, 7, 6, 6, 5, 5, 5, 5, 4, 4, 4, 4, 4, 4, 4, 4,
    8, 8, 8, 7, 8, 7, 6, 6, 8, 7, 6, 6, 5, 5, 5, 5,
    8, 7, 6, 6, 5, 5, 5, 5, 4, 4, 4, 4, 4, 4, 4, 4,
    8, 7, 6, 6, 5, 5, 5, 5, 4, 4, 4, 4, 4, 4, 4, 4,
    3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
    8, 8, 8, 7, 8, 7, 6, 6, 8, 7, 6, 6, 5, 5, 5, 5,
    8, 7, 6, 6, 5, 5, 5, 5, 4, 4, 4, 4, 4, 4, 4, 4,
    8, 7, 6, 6, 5, 5, 5, 5, 4, 4, 4, 4, 4, 4, 4, 4,
    3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
    8, 7, 6, 6, 5, 5, 5, 5, 4, 4, 4, 4, 4, 4, 4, 4,
    3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
    2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
    2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2
];
var PosBit4 = [
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 7,
    8, 8, 8, 8, 8, 8, 8, 7, 8, 8, 8, 7, 8, 7, 6, 6,
    8, 8, 8, 8, 8, 8, 8, 7, 8, 8, 8, 7, 8, 7, 6, 6,
    8, 8, 8, 7, 8, 7, 6, 6, 8, 7, 6, 6, 5, 5, 5, 5,
    8, 8, 8, 8, 8, 8, 8, 7, 8, 8, 8, 7, 8, 7, 6, 6,
    8, 8, 8, 7, 8, 7, 6, 6, 8, 7, 6, 6, 5, 5, 5, 5,
    8, 8, 8, 7, 8, 7, 6, 6, 8, 7, 6, 6, 5, 5, 5, 5,
    8, 7, 6, 6, 5, 5, 5, 5, 4, 4, 4, 4, 4, 4, 4, 4,
    8, 8, 8, 8, 8, 8, 8, 7, 8, 8, 8, 7, 8, 7, 6, 6,
    8, 8, 8, 7, 8, 7, 6, 6, 8, 7, 6, 6, 5, 5, 5, 5,
    8, 8, 8, 7, 8, 7, 6, 6, 8, 7, 6, 6, 5, 5, 5, 5,
    8, 7, 6, 6, 5, 5, 5, 5, 4, 4, 4, 4, 4, 4, 4, 4,
    8, 8, 8, 7, 8, 7, 6, 6, 8, 7, 6, 6, 5, 5, 5, 5,
    8, 7, 6, 6, 5, 5, 5, 5, 4, 4, 4, 4, 4, 4, 4, 4,
    8, 7, 6, 6, 5, 5, 5, 5, 4, 4, 4, 4, 4, 4, 4, 4,
    3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3
];
var PosBit5 = [
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 7,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 7,
    8, 8, 8, 8, 8, 8, 8, 7, 8, 8, 8, 7, 8, 7, 6, 6,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 7,
    8, 8, 8, 8, 8, 8, 8, 7, 8, 8, 8, 7, 8, 7, 6, 6,
    8, 8, 8, 8, 8, 8, 8, 7, 8, 8, 8, 7, 8, 7, 6, 6,
    8, 8, 8, 7, 8, 7, 6, 6, 8, 7, 6, 6, 5, 5, 5, 5,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 7,
    8, 8, 8, 8, 8, 8, 8, 7, 8, 8, 8, 7, 8, 7, 6, 6,
    8, 8, 8, 8, 8, 8, 8, 7, 8, 8, 8, 7, 8, 7, 6, 6,
    8, 8, 8, 7, 8, 7, 6, 6, 8, 7, 6, 6, 5, 5, 5, 5,
    8, 8, 8, 8, 8, 8, 8, 7, 8, 8, 8, 7, 8, 7, 6, 6,
    8, 8, 8, 7, 8, 7, 6, 6, 8, 7, 6, 6, 5, 5, 5, 5,
    8, 8, 8, 7, 8, 7, 6, 6, 8, 7, 6, 6, 5, 5, 5, 5,
    8, 7, 6, 6, 5, 5, 5, 5, 4, 4, 4, 4, 4, 4, 4, 4
];
var PosBit6 = [
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 7,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 7,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 7,
    8, 8, 8, 8, 8, 8, 8, 7, 8, 8, 8, 7, 8, 7, 6, 6,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 7,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 7,
    8, 8, 8, 8, 8, 8, 8, 7, 8, 8, 8, 7, 8, 7, 6, 6,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 7,
    8, 8, 8, 8, 8, 8, 8, 7, 8, 8, 8, 7, 8, 7, 6, 6,
    8, 8, 8, 8, 8, 8, 8, 7, 8, 8, 8, 7, 8, 7, 6, 6,
    8, 8, 8, 7, 8, 7, 6, 6, 8, 7, 6, 6, 5, 5, 5, 5
];
var PosBit7 = [
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 7,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 7,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 7,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 7,
    8, 8, 8, 8, 8, 8, 8, 7, 8, 8, 8, 7, 8, 7, 6, 6
];
var PosBit8 = [
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
    8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 7
];
var PosBit = [
    PosBit1, PosBit2, PosBit3, PosBit4, PosBit5, PosBit6, PosBit7, PosBit8
];
var gContarBits = [
    0, 1, 1, 2, 1, 2, 2, 3, 1, 2, 2, 3, 2, 3, 3, 4,
    1, 2, 2, 3, 2, 3, 3, 4, 2, 3, 3, 4, 3, 4, 4, 5,
    1, 2, 2, 3, 2, 3, 3, 4, 2, 3, 3, 4, 3, 4, 4, 5,
    2, 3, 3, 4, 3, 4, 4, 5, 3, 4, 4, 5, 4, 5, 5, 6,
    1, 2, 2, 3, 2, 3, 3, 4, 2, 3, 3, 4, 3, 4, 4, 5,
    2, 3, 3, 4, 3, 4, 4, 5, 3, 4, 4, 5, 4, 5, 5, 6,
    2, 3, 3, 4, 3, 4, 4, 5, 3, 4, 4, 5, 4, 5, 5, 6,
    3, 4, 4, 5, 4, 5, 5, 6, 4, 5, 5, 6, 5, 6, 6, 7,
    1, 2, 2, 3, 2, 3, 3, 4, 2, 3, 3, 4, 3, 4, 4, 5,
    2, 3, 3, 4, 3, 4, 4, 5, 3, 4, 4, 5, 4, 5, 5, 6,
    2, 3, 3, 4, 3, 4, 4, 5, 3, 4, 4, 5, 4, 5, 5, 6,
    3, 4, 4, 5, 4, 5, 5, 6, 4, 5, 5, 6, 5, 6, 6, 7,
    2, 3, 3, 4, 3, 4, 4, 5, 3, 4, 4, 5, 4, 5, 5, 6,
    3, 4, 4, 5, 4, 5, 5, 6, 4, 5, 5, 6, 5, 6, 6, 7,
    3, 4, 4, 5, 4, 5, 5, 6, 4, 5, 5, 6, 5, 6, 6, 7,
    4, 5, 5, 6, 5, 6, 6, 7, 5, 6, 6, 7, 6, 7, 7, 8
];
var BitPos = [128, 64, 32, 16, 8, 4, 2, 1];
var AntBitPos = [
    127,
    63,
    31,
    15,
    7,
    3,
    1,
];
var RestBitPos = [
    255 - 127,
    255 - 63,
    255 - 31,
    255 - 15,
    255 - 7,
    255 - 3,
    255 - 1,
    255
];
var PrevBitPos = [255, 127, 63, 31, 15, 7, 3, 1];
var BitArray = (function () {
    function BitArray(nBits, toUnos, bColapsed) {
        if (nBits === void 0) { nBits = 0; }
        if (toUnos === void 0) { toUnos = false; }
        if (bColapsed === void 0) { bColapsed = false; }
        this.baModo = BitArray_Colapsado;
        this.baNumBits = 0;
        this.baTamExp = 0;
        this.baTamCol = 0;
        this.baBits = null;
        this.baUnos = -1;
        this.baUnos = 0;
        this.baNumBits = nBits;
        nBits = (nBits + 31) & ~31;
        this.baTamExp = nBits >> 3;
        this.baModo = BitArray_Expandido;
        this.baBits = new Uint8Array(this.baTamExp);
        for (var n = 0; n < this.baTamExp; n++)
            this.baBits[n] = 0;
        if (toUnos && nBits > 0) {
            this.baUnos = -1;
            this.setUnos();
        }
        if (bColapsed)
            this.colapsar();
    }
    BitArray.prototype.destroy = function () {
        if (this.baBits) {
            this.baBits = null;
        }
    };
    BitArray.prototype.intGetBits = function () {
        if (this.baModo == BitArray_Colapsado) {
            if (this.baTamExp == 0)
                this.baTamExp = this.getTamExp();
            var pExp = new Uint8Array(this.baTamExp);
            BitArray.intExpandir(pExp, this.baBits);
            return pExp;
        }
        return this.baBits;
    };
    BitArray.rangeCheck2 = function (nBits, startBit, endBit) {
        if ((startBit < 0) || (startBit >= nBits))
            throw new Error('El bit inicial está fuera de rango');
        if ((endBit < 0) || (endBit > nBits))
            throw new Error('El bit inicial está fuera de rango');
    };
    BitArray.rangeCheck1 = function (nBits, bit) {
        if (bit >= nBits || bit < 0)
            throw new Error('El bit inicial está fuera de rango');
    };
    BitArray.prototype.colapsar = function () {
        if (this.baModo != BitArray_Expandido)
            return false;
        if (this.baTamCol == 0)
            this.baTamCol = BitArray.getTamCol(this.baBits);
        var data = new Uint8Array(this.baTamCol);
        BitArray.intColapsar(data, this.baBits);
        this.baBits = data;
        this.baModo = BitArray_Colapsado;
        return true;
    };
    BitArray.intColapsar = function (pCol, pExp) {
        var tamGrupo = 0, tamCarro = 0, iCarro = 0, iCol = 0;
        var i, j;
        var byteActual;
        var byteGrupo;
        byteGrupo = pExp[0];
        tamGrupo = 1;
        tamCarro = 0;
        for (i = 1; i < pExp.length; ++i) {
            byteActual = pExp[i];
            if (byteGrupo == byteActual) {
                tamGrupo++;
                if (tamGrupo > 0x7FFF) {
                    if (tamCarro != 0) {
                        BitArray.shortToBytes(pCol, iCol, tamCarro);
                        iCol += 2;
                        BitArray.Copy(pExp, iCarro, pCol, iCol, tamCarro);
                        iCol += tamCarro;
                        tamCarro = 0;
                    }
                    BitArray.shortToBytes(pCol, iCol, 0xFFFF);
                    iCol += 2;
                    pCol[iCol++] = byteGrupo;
                    tamGrupo = 1;
                    iCarro = i;
                }
            }
            else {
                if (tamGrupo > 2) {
                    if (tamCarro != 0) {
                        BitArray.shortToBytes(pCol, iCol, tamCarro);
                        iCol += 2;
                        BitArray.Copy(pExp, iCarro, pCol, iCol, tamCarro);
                        iCol += tamCarro;
                        tamCarro = 0;
                    }
                    tamGrupo |= (0x8000);
                    BitArray.shortToBytes(pCol, iCol, tamGrupo);
                    iCol += 2;
                    pCol[iCol++] = byteGrupo;
                    iCarro = i;
                }
                else {
                    for (j = tamGrupo; j != 0; --j) {
                        ++tamCarro;
                        if (tamCarro == (0x7FFF)) {
                            BitArray.shortToBytes(pCol, iCol, tamCarro);
                            iCol += 2;
                            BitArray.Copy(pExp, iCarro, pCol, iCol, tamCarro);
                            iCol += tamCarro;
                            iCarro += tamCarro;
                            tamCarro = 0;
                        }
                    }
                }
                tamGrupo = 1;
                byteGrupo = byteActual;
            }
        }
        if ((tamGrupo > 2) || (tamCarro + tamGrupo > (0x7FFF))) {
            if (tamCarro != 0) {
                BitArray.shortToBytes(pCol, iCol, tamCarro);
                iCol += 2;
                BitArray.Copy(pExp, iCarro, pCol, iCol, tamCarro);
                iCol += tamCarro;
            }
            tamGrupo |= (0x8000);
            BitArray.shortToBytes(pCol, iCol, tamGrupo);
            iCol += 2;
            pCol[iCol++] = byteGrupo;
        }
        else {
            tamCarro += tamGrupo;
            BitArray.shortToBytes(pCol, iCol, tamCarro);
            iCol += 2;
            BitArray.Copy(pExp, iCarro, pCol, iCol, tamCarro);
            iCol += tamCarro;
        }
        return iCol;
    };
    BitArray.prototype.expandir = function () {
        if (this.baModo != BitArray_Colapsado)
            return false;
        this.baBits = this.intGetBits();
        this.baModo = BitArray_Expandido;
        return true;
    };
    BitArray.bytesToShort = function (a, b) {
        return (((a & 0xFF) << 0) | ((b & 0xFF) << 8));
    };
    BitArray.bytesToInt = function (a, b, c, d) {
        return (((a & 0xFF) << 0) | ((b & 0xFF) << 8) | ((c & 0xFF) << 16) | ((d & 0xFF) << 24));
    };
    BitArray.shortToBytes = function (arr, ipos, val) {
        arr[ipos + 0] = ((val >> 0) & 0xFF);
        arr[ipos + 1] = ((val >> 8) & 0xFF);
    };
    BitArray.intToBytes = function (arr, ipos, val) {
        arr[ipos + 0] = ((val >> 0) & 0xFF);
        arr[ipos + 1] = ((val >> 8) & 0xFF);
        arr[ipos + 2] = ((val >> 16) & 0xFF);
        arr[ipos + 3] = ((val >> 24) & 0xFF);
    };
    BitArray.Copy = function (sourceData, sourcePos, destData, destPos, size) {
        destData.set(sourceData.slice(sourcePos, sourcePos + size), destPos);
    };
    BitArray.intExpandir = function (pExp, pCol) {
        var iExp = 0;
        var tamCol = pCol.length;
        var i = 0;
        while (i < tamCol) {
            var cabecera = BitArray.bytesToShort(pCol[i++], pCol[i++]);
            if ((cabecera & 0x8000) != 0) {
                cabecera &= 0x7FFF;
                for (var x = iExp; x < iExp + cabecera; x++)
                    pExp[x] = pCol[i];
                i++;
                iExp += cabecera;
            }
            else {
                for (var x = 0; x < cabecera; x++)
                    pExp[iExp + x] = pCol[i + x];
                i += cabecera;
                iExp += cabecera;
            }
        }
    };
    BitArray.prototype.getNumberOfUnos = function () {
        if (this.baUnos != -1)
            return this.baUnos;
        var cont = 0;
        if (this.baModo == BitArray_Colapsado) {
            var iOrig = 0;
            var i = this.baTamCol;
            while (i > 0) {
                var cabecera = BitArray.bytesToShort(this.baBits[iOrig++], this.baBits[iOrig++]);
                i -= 2;
                if ((cabecera & (0x8000)) != 0) {
                    cabecera &= (0x7FFF);
                    i--;
                    cont += (gContarBits[this.baBits[iOrig++]] * cabecera);
                }
                else {
                    i -= cabecera;
                    while (cabecera != 0) {
                        cont += gContarBits[this.baBits[iOrig++]];
                        cabecera--;
                    }
                }
            }
        }
        else {
            for (var i = 0; i < this.baBits.length; i++)
                cont += gContarBits[this.baBits[i]];
        }
        this.baUnos = cont;
        return cont;
    };
    BitArray.prototype.isAnyOne = function () {
        return this.getNumberOfUnos() != 0;
    };
    BitArray.prototype.isAnyOneFrom = function (ini) {
        if (ini < this.getSize()) {
            var pExp = this.intGetBits();
            var cont = 0;
            var firstMod = ini & 7;
            var first = ini >> 3;
            var end = this.getSize();
            var lastMod = end & 7;
            var last = end >> 3;
            if (firstMod > 0) {
                if (gContarBits[pExp[first] & AntBitPos[firstMod - 1]] > 0)
                    return true;
                first++;
            }
            for (var i = first; i < last; i++)
                if (gContarBits[pExp[i]] > 0)
                    return true;
            if (lastMod > 0)
                if (gContarBits[pExp[last] & RestBitPos[lastMod - 1]] > 0)
                    return true;
        }
        return false;
    };
    BitArray.prototype.getNumberOfUnosLimits = function (ini, end) {
        BitArray.rangeCheck2(this.baNumBits, ini, end);
        var pExp = this.intGetBits();
        var cont = 0;
        var firstMod = ini & 7;
        var first = ini >> 3;
        var lastMod = end & 7;
        var last = end >> 3;
        if (first == last) {
            var mask = 0xFF;
            if (lastMod > 0)
                mask &= RestBitPos[lastMod - 1];
            if (firstMod > 0)
                mask &= AntBitPos[firstMod - 1];
            if (firstMod == 0 && lastMod == 0)
                mask = 0;
            cont += gContarBits[pExp[first] & mask];
        }
        else {
            if (firstMod > 0) {
                cont += gContarBits[pExp[first] & AntBitPos[firstMod - 1]];
                first++;
            }
            for (var i = first; i < last; i++)
                cont += gContarBits[pExp[i]];
            if (lastMod > 0)
                cont += gContarBits[pExp[last] & RestBitPos[lastMod - 1]];
        }
        return cont;
    };
    BitArray.prototype.getNumberOfBloques = function () {
        if (this.baUnos == 0)
            return 0;
        var nBloques = 0;
        var pExp = this.intGetBits();
        var prevActiu = false;
        for (var i = 0; i < this.baTamExp; i++) {
            var b = pExp[i];
            if (b != 0) {
                if (prevActiu && ((b & 0x80) == 0x80))
                    nBloques += gNumBloques[b] - 1;
                else
                    nBloques += gNumBloques[b];
                prevActiu = ((b & 0x01) == 0x01);
            }
            else
                prevActiu = false;
        }
        return nBloques;
    };
    BitArray.prototype.getInicioBloque = function (bloque) {
        var iniFin = this.getBloque(bloque);
        if (iniFin == null)
            return -1;
        return iniFin[0];
    };
    BitArray.prototype.getFinBloque = function (bloque) {
        var iniFin = this.getBloque(bloque);
        if (iniFin == null)
            return -1;
        return iniFin[1];
    };
    BitArray.prototype.getBloque = function (bloque) {
        var pExp = this.intGetBits();
        var prevActiu = false;
        var i = 0;
        var nBloques = 0;
        var readed;
        for (; i < this.baTamExp; i++) {
            var b = pExp[i];
            if (b != 0) {
                var numBlocs = gNumBloques[b];
                if (prevActiu && (b & 0x80) == 0x80)
                    numBlocs--;
                var newNum = nBloques + numBlocs;
                if (newNum > bloque)
                    break;
                nBloques = newNum;
                prevActiu = ((b & 0x01) == 0x01);
            }
            else
                prevActiu = false;
        }
        if (i >= this.baTamExp)
            return null;
        var actByte = pExp[i];
        var bit = 0;
        if (prevActiu)
            while ((actByte & BitPos[bit]) != 0)
                bit++;
        for (; nBloques <= bloque && bit < 7; bit++) {
            if ((actByte & BitPos[bit]) != 0) {
                nBloques++;
                if (nBloques > bloque)
                    break;
                while ((actByte & BitPos[bit]) != 0)
                    bit++;
            }
        }
        var inicio = bit + (i << 3);
        var fin = inicio;
        var pExpLength = pExp.length;
        if ((bit > 0 && (pExp[i] | AntBitPos[bit - 1]) == pExp[i]) || pExp[i] == 0xFF) {
            fin += (8 - bit);
            bit = 0;
            i++;
            while (i < pExpLength && pExp[i] == 0xFF) {
                fin += 8;
                i++;
            }
        }
        if (i < pExpLength)
            while ((pExp[i] & BitPos[fin & 7]) != 0)
                fin++;
        return [inicio, fin];
    };
    BitArray.prototype.getPosBitActivo = function (bitActivo) {
        BitArray.rangeCheck1(this.baNumBits, bitActivo);
        var ibits = 0;
        var ibitsEnd = this.baTamExp;
        var tmpBits = this.intGetBits();
        var BitsActius = gContarBits[tmpBits[ibits] & 0xFF] - 1;
        while (BitsActius < bitActivo) {
            ibits++;
            if (ibits < ibitsEnd)
                BitsActius += gContarBits[tmpBits[ibits] & 0xFF];
            else
                return -1;
        }
        return (PosBit[gContarBits[tmpBits[ibits] & 0xFF] - (BitsActius - bitActivo) - 1][tmpBits[ibits] & 0xFF]) + (ibits << 3);
    };
    BitArray.prototype.getPosBitsActivosRange = function (bitActivo, numElems) {
        BitArray.rangeCheck1(this.baNumBits, bitActivo);
        var ids = new Array();
        var tmpBits = this.intGetBits();
        var bitsActivos = 0;
        for (var theIndex = 0; theIndex < tmpBits.length; theIndex++) {
            var byteAct = tmpBits[theIndex];
            var numActivos = gContarBits[byteAct];
            if ((bitsActivos + numActivos) > bitActivo) {
                var totalBits = theIndex << 3;
                for (var bit = bitActivo - bitsActivos; bit < numActivos; bit++) {
                    var theBit = PosBit[bit][byteAct];
                    if (ids.push(theBit + totalBits) >= numElems)
                        return ids;
                    bitActivo++;
                }
            }
            bitsActivos += numActivos;
        }
        return ids;
    };
    BitArray.prototype.getSize = function () {
        return this.baNumBits;
    };
    BitArray.getTamCol = function (baBits) {
        var tamExp = baBits.length;
        var tamGrupo;
        var i;
        var byteActual;
        var byteGrupo;
        var tamCarro;
        var iCarro;
        var j;
        var tamCol = 0;
        byteGrupo = baBits[0];
        tamGrupo = 1;
        tamCarro = 0;
        iCarro = 0;
        for (i = 1; i < tamExp; ++i) {
            byteActual = baBits[i];
            if (byteGrupo == byteActual) {
                tamGrupo++;
                if (tamGrupo > 0x7FFF) {
                    if (tamCarro != 0) {
                        tamCol += (tamCarro + 2);
                        tamCarro = 0;
                    }
                    tamCol += 3;
                    tamGrupo = 1;
                    iCarro = i;
                }
            }
            else {
                if (tamGrupo > 2) {
                    if (tamCarro != 0) {
                        tamCol += (tamCarro + 2);
                        tamCarro = 0;
                    }
                    tamCol += 3;
                    tamGrupo = 1;
                    iCarro = i;
                }
                else {
                    for (j = tamGrupo; j != 0; --j) {
                        ++tamCarro;
                        if (tamCarro == 0x7FFF) {
                            iCarro += tamCarro;
                            tamCol += (tamCarro + 2);
                            tamCarro = 0;
                        }
                    }
                }
                tamGrupo = 1;
                byteGrupo = byteActual;
            }
        }
        if ((tamGrupo > 2) || (tamCarro + tamGrupo > 0x7FFF)) {
            if (tamCarro != 0)
                tamCol += (tamCarro + 2);
            tamCol += 3;
        }
        else
            tamCol += (tamCarro + tamGrupo + 2);
        return tamCol;
    };
    BitArray.prototype.getTamExp = function () {
        var cabecera;
        this.baTamExp = 0;
        var remBytes = this.baBits.length;
        var i = 0;
        while (remBytes >= 2) {
            cabecera = BitArray.bytesToShort(this.baBits[i++], this.baBits[i++]);
            remBytes -= 2;
            if ((cabecera & (0x8000)) != 0) {
                this.baTamExp += (cabecera & (0x7FFF));
                cabecera = 1;
            }
            else {
                this.baTamExp += cabecera;
            }
            i += cabecera;
            remBytes -= cabecera;
        }
        var oldTamExp = this.baTamExp;
        this.baTamExp = (((this.baTamExp << 3) + 63) & ~63) >> 3;
        var bModified = oldTamExp != this.baTamExp;
        if (bModified)
            this.baTamCol = 0;
        return this.baTamExp;
    };
    BitArray.prototype.insertTib = function (ba, primerBit) {
        throw ('Not Implemented');
    };
    BitArray.prototype.isBitAUno = function (bit) {
        BitArray.rangeCheck1(this.baNumBits, bit);
        if (this.baModo == BitArray_Colapsado) {
            var bitPos = bit >> 3;
            var i = -1;
            var ibits = 0;
            while (i < bitPos) {
                var cabecera = BitArray.bytesToShort(this.baBits[ibits++], this.baBits[ibits++]);
                if ((cabecera & (0x8000)) != 0) {
                    cabecera &= (0x7FFF);
                    i += cabecera;
                    if (i >= bitPos)
                        return ((this.baBits[ibits] & BitPos[bit & 7]) != 0);
                }
                else {
                    i += cabecera;
                    if (i >= bitPos)
                        return ((this.baBits[ibits + (cabecera - (i - bitPos) - 1)] & BitPos[bit & 7]) != 0);
                    ibits += cabecera;
                }
            }
            return false;
        }
        return (this.baBits[bit >> 3] & BitPos[bit & 7]) != 0;
    };
    BitArray.Solapan = function (ba1, ba2) {
        var ba1Bytes = ba1.intGetBits();
        var ba2Bytes = ba2.intGetBits();
        var sz = ba1Bytes.length < ba2Bytes.length ? ba1Bytes.length : ba2Bytes.length;
        for (var i = 0; i < sz; i++) {
            if ((ba1Bytes[i] & ba2Bytes[i]) != 0)
                return true;
        }
        return false;
    };
    BitArray.Base64ToUint8Array = function (data) {
        var raw = atob(data);
        var rawLength = raw.length;
        var baData = new Uint8Array(new ArrayBuffer(rawLength));
        for (var x = 0; x < rawLength; x++) {
            baData[x] = raw.charCodeAt(x);
        }
        return baData;
    };
    BitArray.Parse64 = function (data, expandida, numBits) {
        if (expandida === void 0) { expandida = false; }
        if (numBits === void 0) { numBits = -1; }
        var ba = new BitArray();
        if (!data)
            return ba;
        ba.baUnos = -1;
        ba.baModo = BitArray_Colapsado;
        var baData = BitArray.Base64ToUint8Array(data);
        var i = 0;
        ba.baNumBits = BitArray.bytesToInt(baData[i++], baData[i++], baData[i++], baData[i++]);
        ba.baTamCol = baData.length - i;
        ba.baBits = new Uint8Array(ba.baTamCol);
        ba.baBits.set(baData.slice(i, baData.length), 0);
        ba.baTamExp = ba.getTamExp();
        if (ba.baTamCol == 0)
            expandida = true;
        if (numBits != -1)
            expandida = true;
        if (expandida) {
            ba.baBits = ba.intGetBits();
            ba.baModo = BitArray_Expandido;
        }
        return ba;
    };
    BitArray.prototype.Encode64 = function () {
        var data = null;
        if (this.baModo == BitArray_Expandido) {
            if (this.baTamCol == 0)
                this.baTamCol = BitArray.getTamCol(this.baBits);
            data = new Uint8Array(this.baTamCol);
            BitArray.intColapsar(data, this.baBits);
        }
        else {
            data = this.baBits;
        }
        var dataToEncode = new Uint8Array(data.length + 4);
        BitArray.Copy(data, 0, dataToEncode, 4, data.length);
        BitArray.intToBytes(dataToEncode, 0, this.baNumBits);
        return btoa(String.fromCharCode.apply(null, dataToEncode));
    };
    BitArray.prototype.setBit = function (bit, value) {
        var bModif = false;
        var colapsada = (this.baModo == BitArray_Colapsado);
        BitArray.rangeCheck1(this.baNumBits, bit);
        if (colapsada)
            this.expandir();
        var bActualValue = (this.baBits[bit >> 3] & BitPos[bit & 7]) != 0;
        if (bActualValue != value) {
            if (value) {
                this.baBits[bit >> 3] |= BitPos[(bit) & 7];
                if (this.baUnos != -1)
                    this.baUnos++;
            }
            else {
                this.baBits[bit >> 3] &= ~BitPos[(bit) & 7];
                if (this.baUnos != -1)
                    this.baUnos--;
            }
            this.baTamCol = 0;
            bModif = true;
        }
        if (colapsada)
            this.colapsar();
    };
    BitArray.prototype.setCeros = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var ini = 0;
        var end = this.baNumBits;
        if (args.length > 2) {
            throw new Error('Parametros incorrectos');
        }
        else if (args.length == 2) {
            ini = args[0];
            end = args[1];
        }
        else if (args.length == 1) {
            ini = args[0];
        }
        BitArray.rangeCheck2(this.baNumBits, ini, end);
        var colapsada = (this.baModo == BitArray_Colapsado);
        if (colapsada)
            this.expandir();
        var firstMod = ini & 7;
        var first = ini >> 3;
        var lastMod = end & 7;
        var last = end >> 3;
        if (first == last) {
            var mask = 0xFF;
            if (lastMod > 0)
                mask &= RestBitPos[lastMod - 1];
            if (firstMod > 0)
                mask &= AntBitPos[firstMod - 1];
            if (firstMod == 0 && lastMod == 0)
                mask = 0;
            this.baBits[first] &= (~mask);
        }
        else {
            if (firstMod > 0) {
                this.baBits[first] &= ~AntBitPos[firstMod - 1];
                first++;
            }
            for (var i = first; i < last; i++)
                this.baBits[i] = 0x00;
            if (lastMod > 0)
                this.baBits[last] &= ~RestBitPos[lastMod - 1];
        }
        this.baTamCol = 0;
        this.baUnos = -1;
        if (colapsada)
            this.colapsar();
    };
    BitArray.prototype.setUnos = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var ini = 0;
        var end = this.baNumBits;
        if (args.length > 2) {
            throw new Error('Parametros incorrectos');
        }
        else if (args.length == 2) {
            ini = args[0];
            end = args[1];
        }
        else if (args.length == 1) {
            ini = args[0];
        }
        BitArray.rangeCheck2(this.baNumBits, ini, end);
        var colapsada = (this.baModo == BitArray_Colapsado);
        if (colapsada)
            this.expandir();
        var firstMod = ini & 7;
        var first = ini >> 3;
        var lastMod = end & 7;
        var last = end >> 3;
        if (first == last) {
            var mask = 0xFF;
            if (lastMod > 0)
                mask &= RestBitPos[lastMod - 1];
            if (firstMod > 0)
                mask &= AntBitPos[firstMod - 1];
            if (firstMod == 0 && lastMod == 0)
                mask = 0;
            this.baBits[first] |= mask;
        }
        else {
            if (firstMod > 0) {
                this.baBits[first] |= AntBitPos[firstMod - 1];
                first++;
            }
            for (var i = first; i < last; i++)
                this.baBits[i] = 0xFF;
            if (lastMod > 0)
                this.baBits[last] |= RestBitPos[lastMod - 1];
        }
        this.baTamCol = 0;
        this.baUnos = -1;
        if (colapsada)
            this.colapsar();
    };
    BitArray.prototype.operNotAnd = function (ba) {
        if (ba == null)
            return;
        if (this.baUnos == 0)
            return;
        if (ba.baUnos == 0 && this.baNumBits == ba.baNumBits)
            return;
        var colapsada1 = (this.baModo == BitArray_Colapsado);
        var colapsada2 = (ba.baModo == BitArray_Colapsado);
        var i, tam;
        if (this.baTamExp <= 0)
            this.baTamExp = this.getTamExp();
        if (ba.baTamExp <= 0)
            ba.baTamExp = ba.getTamExp();
        tam = Math.min(this.baTamExp, ba.baTamExp);
        if (colapsada1)
            this.expandir();
        this.baUnos = 0;
        if (!colapsada2) {
            for (i = 0; i < tam; i++) {
                this.baBits[i] &= ((~ba.baBits[i]) & 0xFF);
                this.baUnos += gContarBits[this.baBits[i]];
            }
        }
        else {
            var iOrig = 0, iDest = 0;
            i = tam;
            while (i > 0) {
                var cabecera = BitArray.bytesToShort(ba.baBits[iOrig++], ba.baBits[iOrig++]);
                if ((cabecera & (0x8000)) != 0) {
                    cabecera &= (0x7FFF);
                    if (cabecera > i)
                        cabecera = i;
                    i -= cabecera;
                    var notValue = ((~ba.baBits[iOrig]) & 0xFF);
                    while (cabecera != 0) {
                        this.baBits[iDest] &= notValue;
                        this.baUnos += gContarBits[this.baBits[iDest]];
                        iDest++;
                        cabecera--;
                    }
                }
                else {
                    if (cabecera > i)
                        cabecera = i;
                    i -= cabecera;
                    while (cabecera != 0) {
                        var notValue = ((~ba.baBits[iOrig++]) & 0xFF);
                        this.baBits[iDest] &= notValue;
                        this.baUnos += gContarBits[this.baBits[iDest]];
                        iDest++;
                        cabecera--;
                    }
                }
            }
        }
        for (; tam < this.baTamExp; tam++) {
            this.baBits[tam] = 0;
        }
        this.baTamCol = 0;
        if (colapsada1)
            this.colapsar();
    };
    BitArray.prototype.operAnd = function (ba) {
        if (ba == null)
            return;
        if (ba.baUnos == 0) {
            this.setCeros();
            return;
        }
        var colapsada1 = (this.baModo == BitArray_Colapsado);
        var colapsada2 = (ba.baModo == BitArray_Colapsado);
        var tam;
        if (this.baTamExp <= 0)
            this.baTamExp = this.getTamExp();
        if (ba.baTamExp <= 0)
            ba.baTamExp = ba.getTamExp();
        tam = Math.min(this.baTamExp, ba.baTamExp);
        if (colapsada1)
            this.expandir();
        var i;
        this.baUnos = 0;
        if (!colapsada2) {
            for (i = 0; i < tam; i++) {
                this.baBits[i] &= ba.baBits[i];
                this.baUnos += gContarBits[this.baBits[i]];
            }
        }
        else {
            i = tam;
            var iOrig = 0, iDest = 0;
            while (i > 0) {
                var cabecera = BitArray.bytesToShort(ba.baBits[iOrig++], ba.baBits[iOrig++]);
                if ((cabecera & (0x8000)) != 0) {
                    cabecera &= (0x7FFF);
                    if (cabecera > i)
                        cabecera = i;
                    i -= cabecera;
                    while (cabecera != 0) {
                        this.baBits[iDest] &= ba.baBits[iOrig];
                        this.baUnos += gContarBits[this.baBits[iDest]];
                        iDest++;
                        cabecera--;
                    }
                    iOrig++;
                }
                else {
                    if (cabecera > i)
                        cabecera = i;
                    i -= cabecera;
                    while (cabecera != 0) {
                        this.baBits[iDest] &= ba.baBits[iOrig++];
                        this.baUnos += gContarBits[this.baBits[iDest]];
                        iDest++;
                        cabecera--;
                    }
                }
            }
        }
        for (; tam < this.baTamExp; tam++) {
            this.baBits[tam] = 0;
        }
        this.baTamCol = 0;
        if (colapsada1)
            this.colapsar();
    };
    BitArray.prototype.operNot = function () {
        var i;
        if (this.baModo == BitArray_Colapsado) {
            var iDest = 0;
            i = this.baTamCol;
            while (i != 0) {
                var cabecera = BitArray.bytesToShort(this.baBits[iDest++], this.baBits[iDest++]);
                i -= 2;
                if ((cabecera & 0x8000) != 0) {
                    cabecera &= 0x7FFF;
                    i--;
                    this.baBits[iDest] = ~this.baBits[iDest];
                    iDest++;
                }
                else {
                    i -= cabecera;
                    while (cabecera != 0) {
                        this.baBits[iDest] = ~this.baBits[iDest];
                        cabecera--;
                        iDest++;
                    }
                }
            }
        }
        else {
            for (i = 0; i < this.baTamExp; i++)
                this.baBits[i] = ~this.baBits[i];
        }
        this.baTamCol = 0;
        this.baUnos = -1;
    };
    BitArray.prototype.operOrPartial = function (ba, ini, end) {
        if (ba == null)
            return false;
        if (ba.baUnos == 0)
            return true;
        var colapsada = (this.baModo == BitArray_Colapsado);
        var tmpBits = ba.intGetBits();
        var tam;
        if (this.baTamExp <= 0)
            this.baTamExp = this.getTamExp();
        if (ba.baTamExp <= 0)
            ba.baTamExp = ba.getTamExp();
        tam = Math.min(this.baTamExp, ba.baTamExp);
        var tamP8 = tam * 8;
        if (ini > tamP8)
            return false;
        if (end > tamP8)
            end = tamP8;
        if (colapsada)
            this.expandir();
        var i;
        var firstMod = ini & 7;
        var first = ini >> 3;
        var lastMod = end & 7;
        var last = end >> 3;
        if (first == last) {
            for (i = firstMod; i < lastMod; i++)
                if ((tmpBits[first] & BitPos[i]) != 0)
                    this.baBits[first] |= BitPos[i];
        }
        else {
            if (firstMod > 0) {
                for (i = firstMod; i < 8; i++)
                    if ((tmpBits[first] & BitPos[i]) != 0)
                        this.baBits[first] |= BitPos[i];
                first++;
            }
            for (i = first; i < last; i++)
                this.baBits[i] |= tmpBits[i];
            for (i = 0; i < lastMod; i++)
                if ((tmpBits[last] & BitPos[i]) != 0)
                    this.baBits[last] |= BitPos[i];
        }
        this.baTamCol = 0;
        this.baUnos = -1;
        if (colapsada)
            this.colapsar();
        return true;
    };
    BitArray.prototype.operOr = function (ba) {
        if (ba == null)
            return false;
        if (ba.baUnos == 0)
            return true;
        var colapsada1 = (this.baModo == BitArray_Colapsado);
        var colapsada2 = (ba.baModo == BitArray_Colapsado);
        var tam;
        if (this.baTamExp <= 0)
            this.baTamExp = this.getTamExp();
        if (ba.baTamExp <= 0)
            ba.baTamExp = ba.getTamExp();
        tam = Math.min(this.baTamExp, ba.baTamExp);
        if (colapsada1)
            this.expandir();
        var i;
        this.baUnos = 0;
        if (!colapsada2) {
            for (i = 0; i < tam; i++) {
                this.baBits[i] |= ba.baBits[i];
                this.baUnos += gContarBits[this.baBits[i]];
            }
        }
        else {
            var iOrig = 0, iDest = 0;
            i = tam;
            while (i > 0) {
                var cabecera = BitArray.bytesToShort(ba.baBits[iOrig++], ba.baBits[iOrig++]);
                if ((cabecera & (0x8000)) != 0) {
                    cabecera &= (0x7FFF);
                    if (cabecera > i)
                        cabecera = i;
                    i -= cabecera;
                    while (cabecera != 0) {
                        this.baBits[iDest] |= ba.baBits[iOrig];
                        this.baUnos += gContarBits[this.baBits[iDest]];
                        iDest++;
                        cabecera--;
                    }
                    iOrig++;
                }
                else {
                    if (cabecera > i)
                        cabecera = i;
                    i -= cabecera;
                    while (cabecera != 0) {
                        this.baBits[iDest] |= ba.baBits[iOrig++];
                        this.baUnos += gContarBits[this.baBits[iDest]];
                        iDest++;
                        cabecera--;
                    }
                }
            }
        }
        this.baTamCol = 0;
        if (colapsada1)
            this.colapsar();
        return true;
    };
    BitArray.prototype.getBits = function () {
        return this.baBits;
    };
    BitArray.prototype.clone = function () {
        var ret = new BitArray();
        ret.baModo = this.baModo;
        ret.baNumBits = this.baNumBits;
        ret.baTamCol = this.baTamCol;
        ret.baTamExp = this.baTamExp;
        ret.baUnos = this.baUnos;
        ret.baBits = new Uint8Array(this.baBits.length);
        ret.baBits.set(this.baBits);
        return ret;
    };
    BitArray.prototype.setUnosFromArray = function (arIds) {
        for (var _i = 0, arIds_1 = arIds; _i < arIds_1.length; _i++) {
            var id = arIds_1[_i];
            this.setBit(id, true);
        }
    };
    return BitArray;
}());
//# sourceMappingURL=BitArray.js.map;
define("app/util/BitArray", function(){});

